module.exports = __webpack_public_path__ + "img/studio_social_listening.c21882bd.png";